import { ILoyalty } from '@app/common';
import { crudEndpointsFactory } from '../crud-endpoints.factory';

export const loyaltyApi = crudEndpointsFactory<ILoyalty>()('loyalties', 'Loyalties');